import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui';
export const FreeResources = () => {
  return <section className="py-24 bg-navy-dark relative overflow-hidden border-y border-gold/10" data-id="element-145">
      {/* Background Image with heavy overlay */}
      <div className="absolute inset-0 z-0" data-id="element-146">
        <img src="https://cdn.magicpatterns.com/uploads/kdNMJK6J8XGDc9F14kEVXd/Poza_3.png" alt="Background" className="w-full h-full object-cover opacity-10 mix-blend-luminosity" data-id="element-147" />
        <div className="absolute inset-0 bg-navy-dark/90" data-id="element-148" />
      </div>
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-purple/10 blur-[120px] pointer-events-none z-0" data-id="element-149" />
      <div className="container mx-auto px-6 relative z-10" data-id="element-150">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto text-center" data-id="element-151">
          <div className="inline-block border border-gold/30 px-4 py-1.5 mb-8 bg-navy/50 backdrop-blur-sm" data-id="element-152">
            <span className="font-display text-gold text-xs font-semibold tracking-widest uppercase" data-id="element-153">
              Gratuit pentru tine
            </span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-154">
            Intră în grupul NeuroReset
          </h2>
          <p className="font-sans text-textSub text-lg md:text-xl leading-relaxed mb-10" data-id="element-155">
            Primești acces la workshopuri online gratuite, exerciții practice
            NLP și materiale de lucru cu tine, ca să începi schimbarea chiar
            acum, fără să aștepți.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-156">
            <Button className="w-full sm:w-auto" data-id="element-157">
              Vreau acces gratuit acum
            </Button>
            <Button variant="outline" className="w-full sm:w-auto" data-id="element-158">
              Descoperă workshopurile
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
};